import planillasApi from "../Planillas/api";

/**
 * Contrato frontend -> backend
 *
 * GET /audit-log
 * Query params (todos opcionales):
 *   usuario       string  correo o nombre (coincidencia parcial, case-insensitive)
 *   fechaDesde    string  YYYY-MM-DD  (incluye ese día desde 00:00:00)
 *   fechaHasta    string  YYYY-MM-DD  (incluye ese día hasta 23:59:59)
 *   terminal      string  código de terminal (filtro opcional, exacto o like)
 *   centroCostos  string  resuelve PARQUEADERO + TERMINALES → filtra todas las terminales
 *
 * Orden obligatorio: fecha DESC (más reciente primero)
 *
 * Respuesta esperada:
 * {
 *   data: [{ id, usuario, accion, fecha, entidad_id, terminal, detalle }],
 *   total: number,
 *   parqueaderos?: [{ codPark, nombrePark, centroCostos }],
 *   terminales?: string[]
 * }
 * También se acepta un array plano.
 */
export const consultarAuditLog = async (filtros = {}) => {
  const params = {};

  if (filtros.usuario) {
    params.usuario = filtros.usuario.trim();
  }
  if (filtros.fechaDesde) {
    params.fechaDesde = filtros.fechaDesde;
  }
  if (filtros.fechaHasta) {
    params.fechaHasta = filtros.fechaHasta;
  }
  if (filtros.terminal) {
    params.terminal = filtros.terminal.trim();
  }
  if (filtros.centroCostos) {
    params.centroCostos = String(filtros.centroCostos).trim();
  }

  const respuesta = await planillasApi.get("/audit-log", { params });
  return respuesta.data;
};
